import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const apiClient = axios.create({ baseURL: API });

export const adminClient = () => {
  const token = localStorage.getItem('admin_token') || '';
  return axios.create({
    baseURL: API,
    headers: { 'X-Admin-Token': token },
  });
};

// Public endpoints
export const submitBooking = (data) => apiClient.post('/bookings', data).then(r => r.data);
export const submitReview = (data) => apiClient.post('/reviews', data).then(r => r.data);
export const submitContact = (data) => apiClient.post('/contact', data).then(r => r.data);
export const submitQuoteRequest = (data) => apiClient.post('/quote-request', data).then(r => r.data);
export const subscribeNewsletter = (email) => apiClient.post('/newsletter', { email }).then(r => r.data);
export const fetchReviews = () => apiClient.get('/reviews').then(r => r.data);

// Admin
export const verifyAdmin = () => adminClient().post('/admin/verify').then(r => r.data);
export const fetchStats = () => adminClient().get('/admin/stats').then(r => r.data);
export const fetchAdminBookings = () => adminClient().get('/admin/bookings').then(r => r.data);
export const updateBookingStatus = (id, status) => adminClient().patch(`/admin/bookings/${id}`, { status }).then(r => r.data);
export const fetchAdminReviews = () => adminClient().get('/admin/reviews').then(r => r.data);
export const moderateReview = (id, approved) => adminClient().patch(`/admin/reviews/${id}`, { approved }).then(r => r.data);
export const deleteReview = (id) => adminClient().delete(`/admin/reviews/${id}`).then(r => r.data);
export const fetchAdminContacts = () => adminClient().get('/admin/contact').then(r => r.data);
export const fetchAdminNewsletter = () => adminClient().get('/admin/newsletter').then(r => r.data);
export const fetchAdminQuoteRequests = () => adminClient().get('/admin/quote-requests').then(r => r.data);
export const updateQuoteStatus = (id, status) => adminClient().patch(`/admin/quote-requests/${id}`, { status }).then(r => r.data);
export const deleteQuoteRequest = (id) => adminClient().delete(`/admin/quote-requests/${id}`).then(r => r.data);

export default apiClient;
